<template>
    <div class="modal show fade" id="certifiedMailerModal" tabindex="-1" aria-labelledby="certifiedMailerModal" style="display: block;background:#0000009e" aria-hidden="true" v-if="disputeLetterStore.showCertifiedMailModel">
        <div class="modal-dialog modal-dialog-centered modal-xl two-factor-auth-sms modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <div class="ml-4">
                        <h3>Send Certified Mail</h3>
                        <small v-if="disputeLetterStore.totalLetterSelected > 0">
                            {{disputeLetterStore.certifiedSelected.length}} out of {{disputeLetterStore.totalLetterSelected}} Letter Loaded.
                        </small>
                    </div>
                    <button id="certifiedMailerModalClose" type="button" class="btn-close" data-dismiss="modal" aria-label="Close" @click="closeCertified"><span aria-hidden="true" ref="closePopup">×</span></button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <div class="wizard-tab-content">
                        <div data-v-5e9451fa="" role="tabpanel" id="Cart0" aria-labelledby="step-Cart0" class="wizard-tab-container"
                            style="">
                            <div data-v-5e9451fa="" class="view-list product-checkout mt-0 row" >
                                <div class="items-checkout col-lg-8">
                                    <div class="card ecommerce-card"  v-for="certifiedSelected,index in disputeLetterStore.certifiedSelected">
                                        <!---->
                                        <!---->
                                        <div class="item-img"><a href="#" target="_self" class=""><img
                                                    src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/icons/pdf.png"
                                                    alt="Personal Information Dispute" class=""></a></div>
                                        <!--  -->
                                        <div class="card-body">
                                            <!---->
                                            <!---->
                                            <div class="item-name">
                                                <h6 class="mb-0 b-flex">
                                                    {{certifiedSelected.letter.letter_name}}
                                                </h6>
                                                <span class="item-company">To: &nbsp;<a href="#" target="_self"
                                                    class="company-name"> {{certifiedSelected.letter.credit_bureau_name}} </a>
                                                </span>
                                                <p>
                                                    <small>Number of Pages:  &nbsp;{{certifiedSelected.number_of_pages}}</small>
                                                </p>

                                            </div>
                                            <span class="text-success"></span>
                                            <span class="item-company">
                                                First Page: $
                                                <span v-if="disputeLetterStore.colored == 'yes'">
                                                    <span v-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 1">
                                                        {{disputeLetterStore.certifiedPricing.colorLetterfirstclass}}
                                                    </span>
                                                    <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 2">
                                                        {{disputeLetterStore.certifiedPricing.certifiedMail}}
                                                    </span>
                                                    <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 3">
                                                        {{disputeLetterStore.certifiedPricing.CertifiedReturnReceipt}}
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <span v-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 1">
                                                        {{disputeLetterStore.certifiedPricing.BWFistclassLetter}}
                                                    </span>
                                                    <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 2">
                                                        {{disputeLetterStore.certifiedPricing.certifiedMail}}
                                                    </span>
                                                    <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 3">
                                                        {{disputeLetterStore.certifiedPricing.CertifiedReturnReceipt}}
                                                    </span>
                                                </span>

                                            </span>
                                            <span class="item-company">
                                                Additional Page: $
                                                <span v-if="disputeLetterStore.colored == 'yes'">
                                                    {{(certifiedSelected.number_of_pages - 1)*disputeLetterStore.certifiedPricing.colorLetterAdditionalPage}}
                                                </span>
                                                <span v-else>
                                                    <span>{{(certifiedSelected.number_of_pages - 1)*disputeLetterStore.certifiedPricing.BWLettersAdditionalPage}}</span>
                                                </span>
                                            </span>

                                            <div class="">
                                                <span  class="form-label" id="basic-addon1">Letter Type: </span>
                                                <select class="form-select" aria-label="Default select example" v-model="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id]" @change="onSelectMailType(certifiedSelected.letter.letter_id,certifiedSelected.number_of_pages)">
                                                    <option value="1">First Class</option>
                                                    <option value="2">Certified Mail</option>
                                                    <option value="3">Certified + Return Receipt</option>
                                                  </select>

                                            </div>
                                            <!--<span
                                                 class="text-success">12% off 1 offers Available</span> -->
                                        </div>
                                        <!--  -->
                                        <div class="item-options text-center">
                                            <div class="item-wrapper">
                                                <div class="item-cost">
                                                    <h4 class="item-price">
                                                        <span v-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 1">
                                                            <!-- color enabled  -->
                                                            <span  v-if="disputeLetterStore.colored == 'yes'">
                                                                {{mathRound(disputeLetterStore.certifiedPricing.colorLetterfirstclass+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.colorLetterAdditionalPage)}}
                                                            </span>
                                                            <span  v-else>
                                                                {{mathRound(disputeLetterStore.certifiedPricing.BWFistclassLetter+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.BWLettersAdditionalPage)}}
                                                            </span>
                                                            <!--End color enabled  -->
                                                        </span>
                                                        <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 2">
                                                            <span  v-if="disputeLetterStore.colored == 'yes'">
                                                                {{mathRound(disputeLetterStore.certifiedPricing.certifiedMail+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.colorLetterAdditionalPage)}}
                                                            </span>
                                                            <span  v-else>
                                                                {{mathRound(disputeLetterStore.certifiedPricing.certifiedMail+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.BWLettersAdditionalPage)}}
                                                            </span>
                                                        </span>
                                                        <span v-else-if="disputeLetterStore.selectedMail['selectedMail'+certifiedSelected.letter.letter_id] == 3">
                                                            <span  v-if="disputeLetterStore.colored == 'yes'">
                                                                {{mathRound(disputeLetterStore.certifiedPricing.CertifiedReturnReceipt+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.colorLetterAdditionalPage)}}
                                                            </span>
                                                            <span  v-else>
                                                                {{mathRound(disputeLetterStore.certifiedPricing.CertifiedReturnReceipt+(certifiedSelected.number_of_pages - 1) * disputeLetterStore.certifiedPricing.BWLettersAdditionalPage)}}
                                                            </span>
                                                        </span>

                                                    </h4>
                                                    <p class="card-text shipping"><span class="badge badge-light-success badge-pill">
                                                            <!-- Free Shipping -->
                                                        </span></p>
                                                </div>
                                            </div> 
                                            <button type="button" class="btn mt-1 remove-wishlist btn-light" @click="removeLetter(certifiedSelected.letter.letter_id)"><svg
                                                    xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24"
                                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" class="mr-50 feather feather-x">
                                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                                </svg>
                                                <span>Remove</span>
                                            </button>
                                        </div>
                                        <!---->
                                        <!---->
                                    </div>
                                </div>
                                <div class="checkout-options col-lg-4">
                                    <div class="card">
                                        <!---->
                                        <!---->
                                        <div class="card-body">
                                            <!---->
                                            <!----><label class="section-label mb-1">Price Calculator</label>
                                            <div>
                                                <span style="fontp-weight:bolder;">Options</span>
                                            </div>
                                            <div class="">
                                                <div>
                                                    <span  class="form-label" id="basic-addon1">Letter Type: </span>
                                                </div>
                                                <select class="form-select col-12" aria-label="Default select example" v-model="allMailOption" @change="changeAllOptions(false)">
                                                    <option selected value="1">First Class</option>
                                                    <option value="2">Certified Mail</option>
                                                    <option value="3">Certified + Return Receipt</option>
                                                  </select>
                                            </div>
                                            <div class="">
                                                <div>
                                                    <span  class="form-label" id="basic-addon1">Double Sided: </span>
                                                </div>
                                                <select class="form-select col-12" aria-label="Default select example" v-model="disputeLetterStore.doubleSided">
                                                    <option selected value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                  </select>
                                            </div>
                                            <div class="">
                                                <div>
                                                    <span  class="form-label" id="basic-addon1">Color: </span>
                                                </div>
                                                <select class="form-select col-12" aria-label="Default select example" v-model="disputeLetterStore.colored" v-on:change="changeColorPricing">
                                                    <option selected value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                  </select>
                                            </div>
                                            <div class=" custom-control custom-checkbox mt-75">
                                                <input class="custom-control-input" type="checkbox"
                                                    name="Make_the_recipient_the_sender" value="1" tabindex="4" ref="checkbox" id="Make_the_recipient_the_sender" />
                                                <label class="custom-control-label" for="Make_the_recipient_the_sender">
                                                    Make the recipient the sender
                                                </label> 
                        
                                            </div>
                                            <hr>
                                            <div class="price-details">
                                                <h6 class="price-title">
                                                    Price Details
                                                </h6>
                                                <ul class="list-unstyled">

                                                    <li class="price-detail">
                                                        <div class="detail-title">
                                                            First Page
                                                        </div>
                                                        <div class="detail-amt discount-amt text-success">
                                                            {{disputeLetterStore.collectionOfLettersAndPricing.length}}
                                                        </div>
                                                    </li>
                                                    <li class="price-detail">
                                                        <div class="detail-title">
                                                            Additional Pages
                                                        </div>
                                                        <div class="detail-amt discount-amt text-success">
                                                            {{disputeLetterStore.allpages - disputeLetterStore.collectionOfLettersAndPricing.length}}
                                                        </div>
                                                    </li>
                                                    <li class="price-detail">
                                                        <div class="detail-title">
                                                            Total Letters
                                                        </div>
                                                        <div class="detail-amt discount-amt text-success">

                                                            {{disputeLetterStore.collectionOfLettersAndPricing.length}}
                                                        </div>
                                                    </li>
                                                </ul>
                                                <hr>
                                                <ul class="list-unstyled">
                                                    <li class="price-detail">
                                                        <div class="detail-title detail-total">
                                                            Total
                                                        </div>
                                                        <div class="detail-amt font-weight-bolder">
                                                            ${{disputeLetterStore.certifiedPricing.total}}
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                                                    <button type="button" class="btn btn-primary mb-1 mb-sm-1 mr-0 mr-sm-1 btn-sm waves-effect waves-float waves-light" @click.once="sendLobMailer" :key="sendLobMailerKey"> Pay &amp; Mail </button>
                                                    <button type="button" class="btn btn-outline-secondary mb-1 mb-sm-1 btn-sm waves-effect" @click="closeCertified"> Cancel </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <LoadingScreen/>
</template>
<script>
import {ref,watch} from 'vue'
import { round } from 'mathjs'
import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import LoadingScreen from './components/LoadingScreen.vue'
export default{
    components:{
        LoadingScreen
    },
    props:{
        selected:{
            type:[Object,Array]
        },
        reference:{
            type:[Object,Array,String]
        }
    },
    data(){
        return{
            complete:0,

        }

    },
    setup(props){
        const disputeLetterStore = useDisputeLetterStore();
        const allMailOption = 1,
        closePopup = ref(),
        sendLobMailerKey = ref(1),
        checkbox =  ref();
        const localizationStore = useLocalizationStore();
        watch(disputeLetterStore.certifiedSelected, async (newOption, oldOption) => {
            for (let index = 0; index < newOption.length; index++) {
                const element = newOption[index];
                disputeLetterStore.selectedMail['selectedMail'+element.letter.letter_id] = allMailOption
            }
        })

        return {
            disputeLetterStore,allMailOption,closePopup,sendLobMailerKey,localizationStore,checkbox
        }
    },
    created(){
    },
    methods:{
        closeCertified(){
            this.disputeLetterStore.showCertifiedMailModel = false;
            this.disputeLetterStore.collectionOfLettersAndPricing = [];
            this.allMailOption = 1;
            this.disputeLetterStore.certifiedPricing.total = 0;
            this.disputeLetterStore.$patch((state)=>{
                state.certifiedSelected = [],
                state.colored = 'no',
                state.doubleSided = 'no'
            })
        },
        changeLetterPrice(id){
        },
        changeColorPricing(){
            this.changeAllOptions(true);
        },
        removeLetter(id){
            let letterCollectionandPricing = JSON.parse(JSON.stringify(this.disputeLetterStore.collectionOfLettersAndPricing));
            for (let index = 0; index < letterCollectionandPricing.length; index++) {
                if (letterCollectionandPricing[index].letterId == id){
                    this.disputeLetterStore.certifiedPricing.total = this.mathRound((this.disputeLetterStore.certifiedPricing.total - letterCollectionandPricing[index].letterPrice))
                    this.disputeLetterStore.allpages = this.disputeLetterStore.allpages - letterCollectionandPricing[index].letterPage
                    this.disputeLetterStore.collectionOfLettersAndPricing.splice(index, 1);
                }
            }
            for (let index = 0; index < this.disputeLetterStore.certifiedSelected.length; index++) {
                if (this.disputeLetterStore.certifiedSelected[index].letter.letter_id == id){
                    this.disputeLetterStore.certifiedSelected.splice(index, 1);
                }
            }
            if(this.disputeLetterStore.certifiedSelected.length <= 0){
                this.disputeLetterStore.showCertifiedMailModel = false;
                this.disputeLetterStore.certifiedPricing.total = 0
            }

        },
        changeAllOptions(color){
            let firstPagePricing,restOfPagesPricing;
            if(this.allMailOption == 1){
                if(this.disputeLetterStore.colored == 'yes'){
                    firstPagePricing = this.disputeLetterStore.certifiedPricing.colorLetterfirstclass;
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    firstPagePricing = this.disputeLetterStore.certifiedPricing.BWFistclassLetter;
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
            }else if(this.allMailOption == 2){
                firstPagePricing = this.disputeLetterStore.certifiedPricing.certifiedMail;
                // check if colored is enabled
                if(this.disputeLetterStore.colored == 'yes'){
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
            }else if(this.allMailOption == 3){
                firstPagePricing = this.disputeLetterStore.certifiedPricing.CertifiedReturnReceipt;
                // check if colored is enabled
                if(this.disputeLetterStore.colored == 'yes'){
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    restOfPagesPricing = this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
            }
            this.disputeLetterStore.collectionOfLettersAndPricing =[];
            for (let index = 0; index < this.disputeLetterStore.certifiedSelected.length; index++) {
                const element = this.disputeLetterStore.certifiedSelected[index];
                if(!color){
                    this.disputeLetterStore.selectedMail['selectedMail'+element.letter.letter_id] = this.allMailOption
                }
                this.disputeLetterStore.collectionOfLettersAndPricing.push({
                    letterId:element.letter.letter_id,
                    letterPrice:this.mathRound(firstPagePricing + ((element.number_of_pages - 1) * restOfPagesPricing)),
                    letterPage:element.number_of_pages,
                    extra_service:this.disputeLetterStore.selectedMail['selectedMail'+element.letter.letter_id]
                })
            }
            // get Sum of total price and pages
            this.setAllPagesAndTotal(this.disputeLetterStore.collectionOfLettersAndPricing);
        },
        // function that save total for all the letters
        onSelectMailType(id,letterPage){
            // to filter already added data
            let restOfPagesPricing,totalPricing,firstPagePricing;
            if(this.disputeLetterStore.selectedMail['selectedMail'+id] == '1'){
                // check if colored is enabled
                if(this.disputeLetterStore.colored == 'yes'){
                    firstPagePricing = this.disputeLetterStore.certifiedPricing.colorLetterfirstclass;
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    firstPagePricing = this.disputeLetterStore.certifiedPricing.BWFistclassLetter;
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
                // end of check if colored letter is enabled
                totalPricing = firstPagePricing + restOfPagesPricing

                this.disputeLetterStore.certifiedPricing.total = this.disputeLetterStore.certifiedPricing.total + totalPricing
            }else if(this.disputeLetterStore.selectedMail['selectedMail'+id] == '2'){
                firstPagePricing = this.disputeLetterStore.certifiedPricing.certifiedMail;
                // check if colored is enabled
                if(this.disputeLetterStore.colored == 'yes'){
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
                // end of check if colored letter is enabled
                totalPricing = firstPagePricing + restOfPagesPricing

                this.disputeLetterStore.certifiedPricing.total = this.disputeLetterStore.certifiedPricing.total + totalPricing
            }else if(this.disputeLetterStore.selectedMail['selectedMail'+id] == '3'){
                firstPagePricing = this.disputeLetterStore.certifiedPricing.CertifiedReturnReceipt;
                // check if colored is enabled
                if(this.disputeLetterStore.colored == 'yes'){
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.colorLetterAdditionalPage
                }else{
                    restOfPagesPricing = (letterPage - 1)*this.disputeLetterStore.certifiedPricing.BWLettersAdditionalPage
                }
                // end of check if colored letter is enabled
                totalPricing = firstPagePricing + restOfPagesPricing
                // replace this with Math.js
                this.disputeLetterStore.certifiedPricing.total = this.mathRound(this.disputeLetterStore.certifiedPricing.total + totalPricing)
            }
            // this.disputeLetterStore.certifiedPricing.total = mathRound(this.disputeLetterStore.certifiedPricing.total)
            totalPricing = this.mathRound(totalPricing);
            let selectedLetterData = {
                letterId:id,
                letterPrice:totalPricing,
                letterPage:letterPage,
                extra_service:this.disputeLetterStore.selectedMail['selectedMail'+id]
            }

            let letterCollectionandPricing = JSON.parse(JSON.stringify(this.disputeLetterStore.collectionOfLettersAndPricing));
            if(letterCollectionandPricing.length <= 0){
                this.disputeLetterStore.collectionOfLettersAndPricing.push(selectedLetterData);
            }else{
                for (let index = 0; index < this.disputeLetterStore.collectionOfLettersAndPricing.length; index++) {
                    if (this.disputeLetterStore.collectionOfLettersAndPricing[index].letterId == id){
                        this.disputeLetterStore.collectionOfLettersAndPricing.splice(index, 1);
                        this.disputeLetterStore.collectionOfLettersAndPricing.push(selectedLetterData)
                    }else{
                        this.disputeLetterStore.collectionOfLettersAndPricing.push(selectedLetterData)
                    }
                 }
                 this.disputeLetterStore.collectionOfLettersAndPricing = this.disputeLetterStore.collectionOfLettersAndPricing.filter((el, index, arr) => arr.indexOf(el) === index)
            }
            // get Sum of total price and pages
            this.setAllPagesAndTotal(this.disputeLetterStore.collectionOfLettersAndPricing);
        },
        setAllPagesAndTotal(collectionOfLettersAndPricing){
            // changes this.disputeLetterStore.collectionOfLettersAndPricing to collectionOfLettersAndPricing
            let allPrice = [],allpages = [];

            for (let index = 0; index < collectionOfLettersAndPricing.length; index++) {
                allPrice.push(collectionOfLettersAndPricing[index].letterPrice);
                allpages.push(collectionOfLettersAndPricing[index].letterPage);
            }
            this.disputeLetterStore.allpages = this.disputeLetterStore.sumOfItems(allpages)
            this.disputeLetterStore.certifiedPricing.total = this.mathRound(this.disputeLetterStore.sumOfItems(allPrice)) ;
        },
        // send Mail via lob
        sendLobMailer(){
            let options,url;
            var checkbox = this.checkbox;
            var checked = checkbox.checked?1:0;
            
            for (let index = 0; index < this.disputeLetterStore.collectionOfLettersAndPricing.length; index++) {
                options = {
                    double_sided:this.disputeLetterStore.doubleSided,
                    color:this.disputeLetterStore.colored,
                    extra_service:this.disputeLetterStore.selectedMail['selectedMail'+this.disputeLetterStore.collectionOfLettersAndPricing[index].letterId],
                    make_recipient_sender:checked
                }
                url = this.$router.resolve(
                    {
                        name: 'lob-mailer',
                        params: {
                            id: this.disputeLetterStore.collectionOfLettersAndPricing[index].letterId,
                            client: this.$route.params.client,
                            team: this.$route.params.team
                        }
                    }
                ).href;
                // call the axios method and send lobMailer with option
                axios.post(url,options).then(({data})=>{
                    if(data.error == false){
                        toastr.success(data.message,data.data.letter_name);
                    }else{
                        toastr.error(data.message, 'Error!');
                    }
                })
                this.complete ++;
                if(this.complete == this.disputeLetterStore.collectionOfLettersAndPricing.length){
                    this.complete = 0;
                    this.sendLobMailerKey ++;
                    this.closeCertified();
                }
            }
        },
        mathRound(result){
            return round(result,2);
        }
    }
}
</script>
<style>
.checkout-form-wizard[data-v-5e9451fa] .wizard-tab-content {
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
    background: transparent!important;
    padding: 0;
}
.checkout-form-wizard[data-v-5e9451fa] .wizard-tab-content {
    -webkit-box-shadow: none!important;
}
.steps-transparent .wizard-tab-content, [dir=rtl] .steps-transparent .wizard-tab-content {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.steps-transparent .wizard-tab-content {
    box-shadow: 0 4px 25px 0 rgb(34 41 47 / 10%);
    background-color: #fff;
}
.steps-transparent .wizard-tab-content, .steps-transparent .wizard-tab-content {
    -webkit-box-shadow: 0 4px 25px 0 rgb(34 41 47 / 10%);
}
.ecommerce-application .view-list .ecommerce-card {
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
}
.ecommerce-application .ecommerce-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 25px 0 rgb(34 41 47 / 25%);
}
.ecommerce-application .view-list .ecommerce-card .item-img {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
}
.ecommerce-application .items-checkout .ecommerce-card .item-img img {
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    /*border-right: 1px solid rgba(60,60,60,.26);*/
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    padding: 1.5rem 1rem;
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.ecommerce-application .items-checkout .ecommerce-card .item-name {
    -webkit-box-ordinal-group: 1!important;
    -ms-flex-order: 0!important;
    order: 0!important;
}

.ecommerce-application .items-checkout .ecommerce-card .item-company, .ecommerce-application .items-checkout .ecommerce-card .item-rating {
    margin-bottom: 0.4rem!important;
}

.ecommerce-application .view-list .ecommerce-card .item-company {
    margin: 0.3rem 0 0.5rem;
}
.ecommerce-application .view-list .ecommerce-card .item-company {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-weight: 400;
    font-size: .875rem;
}
.ecommerce-application .items-checkout .ecommerce-card .item-company, .ecommerce-application .items-checkout .ecommerce-card .item-rating {
    margin-bottom: 0.4rem!important;
}
.ecommerce-application .items-checkout .ecommerce-card .item-quantity {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.b-form-spinbutton.form-control {
    padding: 0;
}

.b-form-spinbutton.d-inline-flex:not(.flex-column) {
    width: auto;
}
.b-form-spinbutton.form-control {
    padding: 0;
}
.b-form-spinbutton.d-inline-flex:not(.flex-column) {
    width: auto;
}
.b-form-spinbutton {
    text-align: center;
    background-image: none;
    padding: 0;
}
.b-form-spinbutton.form-control .btn-group-sm>.btn, .b-form-spinbutton.form-control .btn-sm {
    padding: 0.25rem 0.5rem;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.b-form-spinbutton output {
    border: 0;
    background-color: transparent;
    margin: 0;
    padding: 0 0.25rem;
}
.b-form-spinbutton.form-control .btn-group-sm>.btn, .b-form-spinbutton.form-control .btn-sm {
    padding: 0.25rem 0.5rem;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.ecommerce-application .items-checkout .ecommerce-card .delivery-date {
    margin-top: 1.2rem;
    margin-bottom: 0.25rem;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    padding: 1rem;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.text-center {
    text-align: center!important;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper {
    position: relative;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper .item-cost .item-price {
    margin-bottom: 0;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper .item-cost .item-price {
    color: #7367f0;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    padding: 1rem !important;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.text-center {
    text-align: center!important;
}
.ecommerce-application .view-list .ecommerce-card .item-options .shipping {
    margin-top: 0.75rem;
}
.card-text:last-child {
    margin-bottom: 0;
}
.ecommerce-application .items-checkout .ecommerce-card .item-options .btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
}
.ecommerce-application .checkout-options .price-details .price-title {
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
}
.ecommerce-application .checkout-options .price-details .price-title {
    font-weight: 600;
}
.list-unstyled {
    padding-left: 0;
}
.ecommerce-application .checkout-options .price-details .price-detail {
    margin-bottom: 0.75rem;
}
.ecommerce-application .checkout-options .price-details .price-detail {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.items-checkout .card{
    border: none;
    margin-bottom: 2rem;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
    transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
}
.ecommerce-application .view-list .ecommerce-card {
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
}

.checkout-options .card {
    border: none;
    margin-bottom: 2rem;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
    transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
}

</style>
